export default __webpack_public_path__ + "static/media/watch.6ac53342.png";